<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let mode = 'normal';
  export let disabled = false;

  const dispatch = createEventDispatcher();
  const onClick = () => {
    dispatch('click');
  };

  let btnClass = 'iwan-btn';

  $: {
    const disabledClass = disabled ? 'iwan-btn-disabled' : '';
    btnClass = `iwan-btn iwan-btn-${mode} ${disabledClass} ${$$restProps.class || ''}`;
  }
</script>

<div class="iwan-btn-wrapper">
  <button {disabled} class={btnClass} on:click={onClick}>
    <slot />
  </button>
</div>

<style lang="scss">
  .iwan-btn-wrapper {
    display: inline-block;
    width: 100%;
  }
  .iwan-btn {
    border: none;
    display: inline-flex;
    align-items: center;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    justify-content: center;
    border-radius: 6px;
  }
  .iwan-btn-normal {
    width: 100%;
    // TODO:
    // max-width: 327px;
    height: 40px;
    background-image: linear-gradient(180deg, #f6e828 1%, #ffd20c 100%);
    box-shadow: 0 2px 0 0 #ffb538, 0 5px 8px 0 rgba(255, 129, 0, 0.4);
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #795a02;
  }
  .iwan-btn-small {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #8c6e06;
    padding: 6px 16px;
    background: #fff3c3;
    line-height: 20px;
  }
  .iwan-btn-disabled {
    background-image: linear-gradient(180deg, #f5f5f5 1%, #ebebeb 100%);
    box-shadow: 0 2px 0 0 #dbdbdb, 0 5px 8px 0 rgba(0, 0, 0, 0.08);
    color: #bdbdbd;
  }
</style>
